"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Min = void 0;
const BaseAggregator_1 = require("./BaseAggregator");
class Min extends BaseAggregator_1.BaseAggregator {
    init(start) {
        const { value } = this.extractValue(start);
        if (start.termType === 'Literal') {
            return { extremeValue: value, term: start };
        }
        throw new Error('Term should be a literal');
    }
    put(state, term) {
        const extracted = this.extractValue(term);
        if (extracted.value < state.extremeValue && term.termType === 'Literal') {
            return {
                extremeValue: extracted.value,
                term,
            };
        }
        return state;
    }
    result(state) {
        return state.term;
    }
}
exports.Min = Min;
//# sourceMappingURL=Min.js.map